module.exports = " <header> <nav class=\"navbar navbar-light\"> <a href=# class=header__icon id=header__icon v-on:click.stop.prevent=toggleMenu></a> <a class=navbar-brand href=/ > <img src=https://www.21-interactive.com/CONTEXTART.jpg height=60 alt=Logo class=\"d-inline-block align-top\"> </a> <ul class=\"nav navbar-nav float-xs-right\"> <logout></logout> <a href=# class=rightcolumn__icon id=rightcolumn__icon v-on:click.stop.prevent=toggleRightColumn></a> </ul> </nav> </header> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Header.vue
// module id = 480
// module chunks = 1